import { forwardRef } from 'react';
import { css, keyframes } from '@emotion/react';
import styled from '@emotion/styled';
import { Stack, tokens } from '@hotjar/hotsauce';

const SkeletonLoaderAnimation = keyframes`
 0%, 100% { background: ${tokens.color.neutral_300}; }
 50% { background: ${tokens.color.neutral_100}; }
`;

export const SkeletonLoaderOverlay = styled.span<{ isLoading?: boolean }>`
  ${({ isLoading = true }) =>
    isLoading &&
    css`
      > * {
        position: relative;

        &::before {
          content: '';
          position: absolute;
          inset: 0;
          animation: ${SkeletonLoaderAnimation} 4s infinite;
        }
      }

      > svg {
        fill: ${tokens.color.neutral_300};
      }
    `}
`;

export const Container = styled(Stack)`
  background: ${tokens.color.bg_info};
  gap: 0;

  @media ${tokens.getMedia({ minWidth: 'm' })} {
    height: 100vh;
  }
`;

const BodyMaxWidth = styled.div`
  width: min(100%, 1280px);
  margin-inline: auto;
  padding-inline: ${tokens.spacer.x3pt5};

  @media ${tokens.getMedia({ minWidth: 'm' })} {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
    align-items: flex-start;
  }
`;

export const BodyScrollable = styled.div`
  overflow-y: auto;
  padding-block: ${tokens.spacer.x3pt5};
  flex: 1;
`;

export const Body = forwardRef<HTMLDivElement, { children: React.ReactNode }>(
  ({ children }, ref): JSX.Element => (
    <BodyScrollable ref={ref}>
      <BodyMaxWidth>{children}</BodyMaxWidth>
    </BodyScrollable>
  ),
);
